import { RetailerNetworkLocationGroupFilter } from '@occc/graphql';

import { LocationGroupSelectItem } from './add-locations-to-location-group-dialog.types';

import { useGetRetailerNetworkLocationGroupsLazy } from '../../../../data-access/queries';

export const mapLocationGroupsQueryResponseToRawArray = (
  response: ReturnType<typeof useGetRetailerNetworkLocationGroupsLazy>['response'],
): LocationGroupSelectItem[] =>
  response.data ? response.data.map(({ uuid, name }) => ({ uuid, name })) : [];

export const makeRetailerNetworkLocationGroupsFilter =
  (retailerNetworkUuidEquals: string) =>
  (search?: string): RetailerNetworkLocationGroupFilter => ({
    retailerNetworkUuidEquals,
    search: search ? search : undefined,
  });
